import styled from 'styled-components'

const SideBarSize = 78

export const Container = styled.main`
  width: 100vw;
  min-height: calc(100vh - 200px);
  margin-top: 50px;

  color: ${({ theme }) => `rgb(${theme.grayscale[100]})`};

  @media only screen and (min-width: 800px) {
    padding: 0 1.5rem;

    margin: 60px 32px 0 ${SideBarSize + 32}px;
    padding: 0;

    width: unset;
  }

  .scroll-button {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 45px;
    height: 48px;
    background-color: ${({ theme }) => `rgb(${theme.component.background})`};
    color: white;
    border-radius: 50%;
    box-shadow: 1px 4px 20px 0px rgba(0, 0, 0, 0.15);
    text-align: center;
    line-height: 50px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.5s ease-in-out;
    padding-top: 5px;
  }

  .scroll-button.visible {
    opacity: 1;
  }
`

export const Content = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  width: 100%;
  .title {
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;

    .go-back {
      border: 0;
      background: 0;

      height: 20px;

      .icon {
        width: 100%;
        height: 100%;
        color: rgb(${({ theme }) => theme.primary.base});
      }
    }

    .loading-block {
      height: 28px;
      width: 150px;
    }
  }

  .questions-count {
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;

    color: rgb(${({ theme }) => (theme.isDark ? '#A7A7A7' : '#4A4A4A')});

    margin-top: 26px;
    margin-left: 18px;

    display: flex;
    align-items: center;
    gap: 4px;

    .loading-block {
      display: inline-block;
      width: 225px;
      height: 18px;
    }
  }

  @media only screen and (min-width: 800px) {
    .title {
      font-size: 24px;
      line-height: 28px;
    }

    .icon {
      cursor: pointer;
    }

    .questions-count {
      font-size: 14px;
      font-weight: 500;
      line-height: 18px;

      margin-top: 34px;
      margin-left: 38px;
    }

    .mobile {
      display: none;
    }
  }
`

export const Group = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 1.5rem;
  gap: 10px;

  .icon {
    width: 20px;
    height: 20px;

    color: rgb(${({ theme }) => theme.primary.base});

    cursor: pointer;
  }

  @media only screen and (min-width: 800px) {
    padding: 0;
  }
`

export const PaginationFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
`
